import CarnetsSuiviController from './carnets.suivi.controller';

export default {
    template: require('./carnets.suivi.html'),
    controller: CarnetsSuiviController
};
